module.exports = __webpack_public_path__ + "static/media/6.1.fd379602.jpeg";